export const restrictedData: string[] = ["01"]